import { render } from "./Regular.vue?vue&type=template&id=f692bf96&ts=true"
import script from "./Regular.vue?vue&type=script&lang=ts"
export * from "./Regular.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__